{
  "name": "scw-action-tracker",
  "version": "2.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=local",
    "build": "ng build",
    "watch": "ng build --watch",
    "test": "ng test --browsers ChromeHeadless"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^20.3.36",
    "@angular/animations": "^20.3.30",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.30",
    "@angular/compiler": "^20.3.30",
    "@angular/core": "^20.3.30",
    "@angular/forms": "^20.3.30",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.30",
    "@angular/platform-browser-dynamic": "^20.3.30",
    "@angular/router": "^20.3.30",
    "@angular/service-worker": "^20.3.30",
    "@formio/angular": "^9.0.0-rc.3",
    "@formio/js": "5.2.0",
    "@microsoft/applicationinsights-web": "^3.3.5",
    "@ngrx/component-store": "^19.0.1",
    "@ngrx/effects": "^19.0.1",
    "@ngrx/operators": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@winarg/ngx-cron-editor": "^18.0.1",
    "angular2-multiselect-dropdown-ivy": "^1.0.4",
    "cronstrue": "^2.57.0",
    "dayjs": "^1.11.13",
    "lodash": "^4.17.21",
    "moment-timezone": "^0.5.47",
    "ngx-daterangepicker-material": "^6.0.4",
    "ngx-editor": "^18.0.0",
    "ngx-webcam": "^0.4.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^19.1.0",
    "@angular-eslint/eslint-plugin-template": "^19.1.0",
    "@angular-eslint/template-parser": "^19.1.0",
    "@angular/build": "^20.3.36",
    "@angular/cli": "^20.3.36",
    "@angular/compiler-cli": "^20.3.30",
    "@angular/language-service": "^20.3.30",
    "@angular/localize": "^20.3.30",
    "@eslint/compat": "^1.2.7",
    "@eslint/eslintrc": "^3.3.0",
    "@eslint/js": "^9.21.0",
    "@stylistic/eslint-plugin": "^4.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.15",
    "@typescript-eslint/eslint-plugin": "^8.69.0",
    "@typescript-eslint/parser": "^8.69.0",
    "eslint": "^9.20.1",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-sonarjs": "^3.0.2",
    "globals": "^16.0.0",
    "jasmine-core": "^5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.5.1",
    "prettier-plugin-organize-imports": "^4.1.0",
    "typescript": "~5.9.3"
  }
}
